import { render, staticRenderFns } from "./withBefore.vue?vue&type=template&id=4b9ae41a&scoped=true"
import script from "./withBefore.vue?vue&type=script&lang=js"
export * from "./withBefore.vue?vue&type=script&lang=js"
import style0 from "./withBefore.vue?vue&type=style&index=0&id=4b9ae41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ae41a",
  null
  
)

export default component.exports